import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


const CartPage = () => {
  return (
    <Box>
      <Typography>Cart Page</Typography>
    </Box>
  );
};

export default CartPage;
